import { render, staticRenderFns } from "./TaggingListFooter.vue?vue&type=template&id=bef747b8"
import script from "./TaggingListFooter.vue?vue&type=script&lang=js"
export * from "./TaggingListFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports